import Image from 'next/image'

interface LogoProps {
  className?: string
  container?: string
  size?: number
}

/**
 * Renders the Atlas wordmark, swapping between black/white variants based
 * on theme. Both variants are rendered and CSS-toggled via Tailwind's
 * `dark:` variant — the previous useMounted() approach flashed the
 * light-mode logo on initial paint because the server render and first
 * client render both saw `mounted=false`. next-themes sets `.dark` on
 * `<html>` via a blocking inline script before hydration, so CSS-based
 * switching paints the correct variant immediately.
 */
export function Logo({ container, size = 120 }: LogoProps) {
  return (
    <div className={container}>
      <div className="relative" style={{ width: size, height: size / 2 }}>
        <Image
          src="/atlas/atlas-logo-black.svg"
          alt="Atlas Logo"
          fill
          sizes={`${size}px`}
          className="object-contain drop-shadow-lg dark:hidden"
          priority
          fetchPriority="high"
        />
        <Image
          src="/atlas/atlas-logo-white.svg"
          alt=""
          fill
          sizes={`${size}px`}
          className="hidden object-contain drop-shadow-lg dark:block"
          priority
          fetchPriority="high"
          aria-hidden
        />
      </div>
    </div>
  )
}
